import variables from '@/styles/element-variables.scss'

const setting = {
  state: {
    theme: variables.theme,
    showSettings: true,
    tagsView: true,
    fixedHeader: true,
    sidebarLogo: false
  },
  getters: {

  },
  mutations: {
    CHANGE_SETTING: (state, { key, value }) => {
      if (state.hasOwnProperty(key)) {
        state[key] = value
      }
    }
  },
  actions: {
    changeSetting({ commit }, data) {
      commit('CHANGE_SETTING', data)
    }
  }
}

export default setting
